module.exports = __webpack_public_path__ + "img/photo.935dbda0.png";